import {
  IItemTag,
  ITagSimple,
  ITagValidation,
  IServerTagValidation,
} from '../types';

const tagWithType = (type?: string) => (tag: IItemTag): ITagSimple => ({
  ...tag,
  type,
});

export const transformServerValidation = ({
  duplicateErrors,
  duplicateWarnings,
  validationErrors,
}: IServerTagValidation): ITagValidation<ITagSimple> => ({
  errors: duplicateErrors
    .map(tagWithType('duplicate'))
    .concat(validationErrors.map(tagWithType('validation'))),
  warnings: duplicateWarnings.map(tagWithType()),
});



// WEBPACK FOOTER //
// ./src/views/Admin/Items/services/transformServerValidation.ts